import type { AppModule, CbTemplateCategory } from '@mgCommon/types';
import { create } from 'zustand';

// Techdebt - move each of these to a separate file into @app/store folder

type CampaignType = {
  campaignType?: CbTemplateCategory;
  setCampaignType: (campaignType: CbTemplateCategory) => void;
};

export const useCampaignType = create<CampaignType>()(set => ({
  campaignType: undefined,
  setCampaignType: campaignType => set({ campaignType }),
}));

type CurrentModule = {
  currentModule?: AppModule;
  setCurrentModule: (currentModule: AppModule) => void;
};

export const useCurrentModule = create<CurrentModule>()(set => ({
  currentModule: undefined,
  setCurrentModule: currentModule => set({ currentModule }),
}));
